export default __webpack_public_path__ + "static/media/Android.2ae487ae.svg";